<template>
	<div id="building" class="page">
		<dv-full-screen-container class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body">
				<Navbar @logout="logout" :buildingSelect='buildingSelect' :navbarType='navbarType' :building='building' :buildingName='buildingName'
					@second="recordProgress" />
				<div class="body-box">
					<div class="building-box">
						<div style="margin-left: 0.3rem;">
							<div>
								<buindingLeftTop :building='building' />
							</div>
							<div class="mt-3">
								<buindingLeftCenter :building='building' />
							</div>
							<div class="mt-3">
								<buindingLeftBottom :building='building' />
							</div>
						</div>
						<div style="margin-left: 0.25rem;">
							<div>
								<buindingRightTop :building='building' />
							</div>
							<div class="mt-3 building-rightBox">
								<div>
									<buindingRightBottom1 :building='building' />
								</div>
								<div style="margin-left: 0.3rem;">
									<buindingRightBottom2 :building='building' />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</dv-full-screen-container>
	</div>
</template>

<script>
	import Navbar from "../layout/Navbar";
	import buindingLeftTop from "./building/buindingLeftTop";
	import buindingLeftCenter from "./building/buindingLeftCenter";
	import buindingLeftBottom from "./building/buindingLeftBottom";
	import buindingRightTop from "./building/buindingRightTop";
	import buindingRightBottom1 from "./building/buindingRightBottom1";
	import buindingRightBottom2 from "./building/buindingRightBottom2";
	import Cookies from 'js-cookie';

	export default {
		data() {
			return {
				loading: true,
				currtime: "",
				navbarType: true,
				buildingSelect: [],
				buildingName: '',
				building: ''
			};
		},
		components: {
			Navbar,
			buindingLeftTop,
			buindingLeftCenter,
			buindingLeftBottom,
			buindingRightTop,
			buindingRightBottom1,
			buindingRightBottom2
		},
		mounted() {
			if(this.$route.params.building){
				Cookies.set('building', this.$route.params.building)
				Cookies.set('buildingName', this.$route.params.buildingName)
				this.building = this.$route.params.building
				this.buildingName = this.$route.params.buildingName
			}
			this.getBuilding();
			this.cancelLoading();
			// 定时刷新当前时间
			// this.currentTime();
		},
		methods: {
			async getBuilding() {
				await this.$axios.get("/api/buildings").then(res => {
					let buildingSelect = []
					for (let item of res.data.data) {
						buildingSelect.push({
							label: item.abbreviation,
							value: String(item.id)
						})
					}
					this.buildingSelect = buildingSelect
					if(Cookies.get('building')!=undefined){
						this.building = Cookies.get('building')
						this.buildingName = Cookies.get('buildingName')
					}else{
						Cookies.set('building', buildingSelect[0].value)
						Cookies.set('buildingName', buildingSelect[0].label)
						this.building = buildingSelect[0].value
						this.buildingName = buildingSelect[0].label
					}
				})
			},
			// getTime: function() {
			// 	var _this = this;
			// 	let yy = new Date().getFullYear();
			// 	let mm = new Date().getMonth() + 1;
			// 	let dd = new Date().getDate();
			// 	let hh = new Date().getHours();
			// 	let mf =
			// 		new Date().getMinutes() < 10 ?
			// 		"0" + new Date().getMinutes() :
			// 		new Date().getMinutes();
			// 	let ss =
			// 		new Date().getSeconds() < 10 ?
			// 		"0" + new Date().getSeconds() :
			// 		new Date().getSeconds();
			// 	_this.currtime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
			// },
			// currentTime() {
			// 	setInterval(this.getTime, 1000);
			// },
			cancelLoading() {
				setTimeout(() => {
					this.loading = false;
				}, 1000);
			},
			logout() {
				this.$axios.post("/api/logout").then(res => {
					if (process.env.NODE_ENV === "production") {
					  Cookies.remove('token', { domain: "hzng-iot.com" });
					} else {
					  Cookies.set('token', '', -1)
					}
					this.$router.replace("/login");
				})
			},
			recordProgress: function(val) { //val用于接收子组件传过来的值
				this.building = val[0]
				this.buildingName = val[1]
			},
		},
	};
</script>

<style lang="scss">
	@import "../assets/scss/index.scss";

	.building-box {
		display: flex;

		.building-rightBox {
			display: flex;
			// grid-template-columns: 50% 50%;
		}
	}
</style>
